import React from 'react';

export const NavigationPrev = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.33325 12L5.33325 8L9.33325 4L10.2666 4.93333L7.19992 8L10.2666 11.0667L9.33325 12Z"
                fill="#757575"
            />
        </svg>
    );
};
